import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { BsList, BsX } from 'react-icons/bs';

const Header = ({ onShowInterest }) => {
  const navigate = useNavigate();  
  const location = useLocation(); 
  const [activeSection, setActiveSection] = useState('');
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const appStoreUrl = "https://apps.apple.com/ng/app/nisa-care/id6767461961";
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.project.nisacare";

  // Scroll spy effect
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['features', 'how-it-works', 'community', 'mission', 'faq'];
      const scrollPosition = window.scrollY + 150;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;
          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveSection(section);
            break;
          }
        }
      }
      
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, target) => {
    e.preventDefault();
    const element = document.getElementById(target);

    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      setActiveSection(target);
    } else {
      navigate('/', { state: { scrollTo: target } });
    }

    setExpanded(false);
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setExpanded(false);
  };

  return (
    <div className="header-wrapper">
      <div className={`header-container ${scrolled ? 'scrolled' : ''}`}>
        <Navbar 
          expand="lg" 
          className="header-navbar" 
          expanded={expanded} 
          onToggle={setExpanded}
        >
          <Container fluid className="px-2 px-sm-3">
            {/* Logo - Left */}
            <Navbar.Brand 
              href="/" 
              onClick={handleLogoClick} 
              className="d-flex align-items-center flex-shrink-0"
            >
              <img src="/images/logo.png" alt="Nisa Care Logo" className="header-logo" />
            </Navbar.Brand>

            {/* Mobile Toggle Only - No badges outside menu */}
            <div className="d-flex d-lg-none align-items-center gap-1 flex-shrink-0">
              <Navbar.Toggle 
                aria-controls="navbar-nav" 
                className="border-0 p-1"
                onClick={() => setExpanded(!expanded)}
              >
                {expanded ? <BsX size={28} /> : <BsList size={28} />}
              </Navbar.Toggle>
            </div>

            {/* Desktop: Full Nav with Download Buttons */}
            <Navbar.Collapse id="navbar-nav">
              <Nav className="mx-auto align-items-center gap-2 gap-lg-4">
                <Nav.Link
                  href="#features"
                  className={`nav-link-custom ${activeSection === 'features' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'features')}
                >
                  Features
                </Nav.Link>
                <Nav.Link
                  href="#how-it-works"
                  className={`nav-link-custom ${activeSection === 'how-it-works' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'how-it-works')}
                >
                  How it works
                </Nav.Link>
                <Nav.Link
                  href="#community"
                  className={`nav-link-custom ${activeSection === 'community' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'community')}
                >
                  Community
                </Nav.Link>
                <Nav.Link
                  href="#mission"
                  className={`nav-link-custom ${activeSection === 'mission' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'mission')}
                >
                  Mission
                </Nav.Link>
                <Nav.Link
                  href="#faq"
                  className={`nav-link-custom ${activeSection === 'faq' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'faq')}
                >
                  FAQ
                </Nav.Link>
              </Nav>

              {/* Desktop Download Buttons */}
<div class="header-download-buttons d-flex gap-2 flex-shrink-0">
  <a 
    href="https://apps.apple.com/ng/app/nisa-care/id6767461961" 
    target="_blank" 
    rel="noopener noreferrer" 
    class="app-store-badge-header"
    aria-label="Download on the App Store"
  >
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"></path>
      <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"></path>
    </svg>
    <span>
      <small>Download</small>
      <strong>App Store</strong>
    </span>
  </a>
  <a 
    href="https://play.google.com/store/apps/details?id=com.project.nisacare" 
    target="_blank" 
    rel="noopener noreferrer" 
    class="play-store-badge-header"
    aria-label="Get it on Google Play"
  >
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.222 9.374c1.037-.61 1.037-2.137 0-2.748L11.528 5.04 8.32 8l3.207 2.96zm-3.595 2.116L7.583 8.68 1.03 14.73c.201 1.029 1.36 1.61 2.303 1.055zM1 13.396V2.603L6.846 8zM1.03 1.27l6.553 6.05 3.044-2.81L3.333.215C2.39-.341 1.231.24 1.03 1.27"></path>
    </svg>
    <span>
      <small>Get it on</small>
      <strong>Google Play</strong>
    </span>
  </a>
</div>

              {/* Mobile Download Buttons - Inside Menu */}
<div class="header-mobile-downloads d-lg-none mt-3 pt-3 border-top border-gray-200">
  <p class="mobile-download-label">Download the App</p>
  <div class="d-flex gap-2 justify-content-center flex-wrap">
    <a 
      href="https://apps.apple.com/ng/app/nisa-care/id6767461961" 
      target="_blank" 
      rel="noopener noreferrer" 
      class="mobile-download-btn app-store-mobile"
      aria-label="Download on App Store"
    >
      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="20" width="20" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"></path>
        <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"></path>
      </svg>
      <span>
        <small>Download</small>
        <strong>App Store</strong>
      </span>
    </a>
    <a 
      href="https://play.google.com/store/apps/details?id=com.project.nisacare" 
      target="_blank" 
      rel="noopener noreferrer" 
      class="mobile-download-btn play-store-mobile"
      aria-label="Get it on Google Play"
    >
      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="20" width="20" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.222 9.374c1.037-.61 1.037-2.137 0-2.748L11.528 5.04 8.32 8l3.207 2.96zm-3.595 2.116L7.583 8.68 1.03 14.73c.201 1.029 1.36 1.61 2.303 1.055zM1 13.396V2.603L6.846 8zM1.03 1.27l6.553 6.05 3.044-2.81L3.333.215C2.39-.341 1.231.24 1.03 1.27"></path>
      </svg>
      <span>
        <small>Get it on</small>
        <strong>Google Play</strong>
      </span>
    </a>
  </div>
</div>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </div>
  );
};

export default Header;